"use strict";

var curry = require("../Strict/curry.js");

var rejectL = require("./rejectL.js");

var some = require("../Strict/some.js");

var ifElse = require("../Strict/ifElse.js");

module.exports = curry(function uniqueWithL(f, iter) {
  const res = [];
  return rejectL(ifElse(a => some(v => f(a, v), res), _ => true, a => void res.push(a)), iter);
});